<template>
  <div>
    <v-card>
      <v-toolbar>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title
          >Редактировать ситуацию у клиента:
          {{ editedItem.name }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn @click="save"> <v-icon left>save</v-icon>Записать </v-btn>
      </v-toolbar>

      <v-card-text class="mt-5">
        <v-text-field v-model="editedItem.name" label="Название"></v-text-field>
        <v-select
          v-model="editedItem.active"
          :items="activate"
          item-text="label"
          item-value="value"
          label="Активировано:"
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">Отмена (закрыть)</v-btn>
        <v-btn @click="save">Записать</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      activate: [
        { label: "да", value: 1 },
        { label: "нет", value: 0 },
      ],
      editedItem: {},
    };
  },
  mounted() {
    this.editedItem = this.$store.getters.getCurrentSituationCS;
    this.setTitle(`Редактировать ситуацию у клиента: ${this.editedItem.name}`);
  },
  methods: {
    close() {
      this.$store.commit("SET_CURRENT_SITUATIONCS", {});
      this.$router.push({ name: "calcsettings" });
    },
    save() {
      if (this.editedItem.name == "") {
        return;
      }

      this.$store.dispatch("updateSituationCS", this.editedItem).then(() => {
        this.$store.commit("SET_CURRENT_SITUATIONCS", {});
        Swal.fire({
          icon: "success",
          title: "Данные сохранились",
          text: "Ситуация у клиента удачно изменен",
        });
      });
      this.$router.push({ name: "calcsettings" });
    },
  },
};
</script>

<style lang="scss"></style>
